module.exports = __webpack_public_path__ + "static/vs-58dc42d7ea384e753541e680bc0dfb51.png";